import { ChangeEvent, Dispatch, SetStateAction } from 'react';

import { Icon } from '@/components/Icon';

interface InputSearchProps {
  onSearch: (value: string) => void;
  onChange?: Dispatch<SetStateAction<string>>;
  onFocus?: () => void;
  onBlur?: () => void;
  onReset?: () => void;
  onSubmit?: (value: string) => void;
  placeholder?: string;
  value?: string;
  disabled?: boolean;
}

export const InputSearch = ({
  onSearch,
  onChange,
  onFocus,
  onBlur,
  onReset,
  onSubmit,
  placeholder = 'Rechercher',
  value,
  disabled,
}: InputSearchProps) => {
  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    e.preventDefault();
    const value = e.target.value;
    onChange && onChange(value);
    onSearch(value);
  };

  const handleReset = () => {
    onReset && onReset();
  };

  return (
    <label className="relative input-wrapper input-with-icon">
      <Icon name="search" className="w-6 h-6 -ms-1" />
      <input
        type="text"
        value={value}
        placeholder={placeholder}
        onChange={handleChange}
        onKeyDown={(e) => {
          if (e.key === 'Enter') onSubmit(value);
        }}
        aria-label="input-search"
        onFocus={onFocus}
        onBlur={onBlur}
        disabled={disabled}
      />
      {value && (
        <button onClick={handleReset} className="absolute top-1.5 right-1.5 text-brand-neutral-300">
          <Icon name="close" className="!text-2xl" />
        </button>
      )}
    </label>
  );
};
